'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReviewsModal = exports.ReviewsModalUnwrapped = exports.mapStateToProps = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _PagePromotion = require('components/PagePromotion');

var _Review = require('components/VenueDetail/Review');

var _Modal = require('decorators/Modal/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _multitrack = require('helpers/multitrack');

var _bound = require('redux/saga/entities/bound');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  var venueId = state.features.explore.venueId;


  var venue = _bound.venueByIdV2.data(state, venueId);

  return {
    venue: venue,
    reviews: _bound.reviewsForVenue.data(state, venueId + '_page0').reviews
  };
};

var ReviewsModalUnwrapped = exports.ReviewsModalUnwrapped = function (_Component) {
  (0, _inherits3.default)(ReviewsModalUnwrapped, _Component);

  function ReviewsModalUnwrapped(props) {
    (0, _classCallCheck3.default)(this, ReviewsModalUnwrapped);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ReviewsModalUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(ReviewsModalUnwrapped)).call(this, props));

    _this.handleOfferClick = _this.handleOfferClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ReviewsModalUnwrapped, [{
    key: 'handleOfferClick',
    value: function handleOfferClick() {
      (0, _multitrack.ga)('Explore Studios', 'Clicked Studio Reviews CTA', this.props.venue.id);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          venue = _props.venue,
          reviews = _props.reviews;


      return _react2.default.createElement(
        'div',
        { className: 'explore__modal explore__modal--reviews' },
        _react2.default.createElement(
          'h4',
          null,
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'modal.reviews.title',
            defaultMessage: 'Reviews of {venue}',
            values: {
              venue: venue.name
            }
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'review__list' },
          reviews.slice(0, 10).map(function (review) {
            return _react2.default.createElement(_Review.Review, {
              key: review.rating_id,
              createdOn: new Date(review.created_on * 1e3),
              nameOfClass: review.class_name,
              teacherName: review.teacher_name,
              rating: parseInt(review.rating, 10),
              review: review.review
            });
          })
        ),
        _react2.default.createElement(_PagePromotion.PagePromotionCta, {
          extraClassForWrapper: 'explore__offer',
          extraClassForLink: 'bt--primary modal__closer _optimizely_search_test',
          onClick: this.handleOfferClick
        })
      );
    }
  }]);
  return ReviewsModalUnwrapped;
}(_react.Component);

ReviewsModalUnwrapped.propTypes = {
  venue: _propTypes2.default.object.isRequired,
  reviews: _propTypes2.default.array
};

var ReviewsModal = exports.ReviewsModal = (0, _Modal2.default)({ headerClass: 'modal--640' })((0, _reactRedux.connect)(mapStateToProps)(ReviewsModalUnwrapped));